import QTable from 'quasar/src/components/table/QTable.js';

export const adminDepartmentIndexPageTableColumn = (): QTable['columns'] => [
  {
    name: 'title',
    field: 'title',
    label: 'عنوان',
    align: 'left',
    classes: 'max-width-200'
  },
  {
    name: 'active',
    field: 'active',
    label: 'وضعیت',
    align: 'center'
  },
  {
    name: 'contactable',
    field: 'contactable',
    label: 'فعال در تیکت',
    align: 'center'
  },
  {
    name: 'chat_id',
    field: 'chat_id',
    label: 'ربات تلگرام',
    align: 'center'
  },
  {
    name: 'supporters_count',
    field: 'supporters_count',
    label: 'تعداد پشتیبان',
    align: 'center'
  },
  {
    name: 'tickets_count',
    field: 'tickets_count',
    label: 'تیکت در حال اجرا',
    align: 'center'
  },
  {
    name: 'actions',
    field: '',
    label: '',
    align: 'center'
  }
]
